import React, { useEffect, useState } from "react";
import axios from "axios";
import { Spin, Tag, Typography, Divider, Upload, Tooltip, message, Checkbox } from "antd";
import { InboxOutlined, SwapOutlined, EyeOutlined, FilePdfOutlined } from "@ant-design/icons";
import { ModalItem, ButtonItem, InputItem, ListaItems } from "../../../../../Components/Items";
import SelectDocumentoItem from "../../../../../Components/SelectDocumentoItem";
import SelectClientesItem from "../../../../../Components/SelectClientesItem";
import SelectProveedoresItem from "../../../../../Components/SelectProveedoresItem";
import SelectInsumosItem from "../../../../../Components/SelectInsumosItem";
import SelectLeadsItem from "../../../../../Components/SelectLeadsItem";
import SelectContactosItem from "../../../../../Components/SelectContactosItem";
import { WA } from "../../theme";
import {
  analizarPlantilla,
  construirComponentsEnvio,
  botonesUrlDinamicos,
  rellenar,
  etiquetaEstado,
  etiquetaModelo,
  selectorDeModelo,
  CATEGORIAS,
  PreviewPlantilla,
  valoresEjemplo,
} from "../Helpers/plantillasHelpers";

const { Text } = Typography;

// Modelos cuyo PDF se puede generar y adjuntar como encabezado de documento.
const MODELOS_PDF = ["cotizacion", "pedido", "venta", "ordencompra"];

const etiquetaVar = {
  fontSize: 12,
  fontWeight: 600,
  color: WA.turquesa,
  background: "rgba(0,191,214,0.12)",
  border: "1px solid rgba(0,191,214,0.35)",
  borderRadius: 6,
  padding: "4px 8px",
  minWidth: 120,
  textAlign: "center",
  whiteSpace: "nowrap",
};
const FilaVar = ({ etiqueta, children }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
    <span style={etiquetaVar}>{etiqueta}</span>
    <div style={{ flex: 1 }}>{children}</div>
  </div>
);

// Buscador dinámico del documento según el modelo de la plantilla.
const BuscadorModelo = ({ modelo, headersToken, empresaId, onSelect }) => {
  const cfg = selectorDeModelo(modelo);
  if (!cfg) return null;
  const dd = { zIndex: 1300 };
  if (cfg.tipo === "documento") {
    return (
      <SelectDocumentoItem
        tipo={cfg.documentoTipo}
        headersToken={headersToken}
        empresaId={empresaId}
        width="100%"
        style={{ width: "100%" }}
        placeholder="Buscar..."
        dropdownStyle={dd}
        onChange={(id) => id && onSelect(id)}
      />
    );
  }
  if (cfg.tipo === "cliente") {
    return <SelectClientesItem headersToken={headersToken} empresaId={empresaId} width="100%" style={{ width: "100%" }} placeholder="Buscar cliente..." dropdownStyle={dd} onChange={(id) => id && onSelect(id)} />;
  }
  if (cfg.tipo === "proveedor") {
    return <SelectProveedoresItem headersToken={headersToken} empresaId={empresaId} width="100%" style={{ width: "100%" }} placeholder="Buscar proveedor..." dropdownStyle={dd} onChange={(id) => id && onSelect(id)} />;
  }
  if (cfg.tipo === "insumo") {
    return <SelectInsumosItem headersToken={headersToken} empresaId={empresaId} width="100%" dropdownStyle={dd} dropdownMatchSelectWidth onChange={(id) => id && onSelect(id)} />;
  }
  if (cfg.tipo === "lead") {
    return <SelectLeadsItem headersToken={headersToken} empresaId={empresaId} width="100%" style={{ width: "100%" }} placeholder="Buscar lead..." dropdownStyle={dd} onChange={(id) => id && onSelect(id)} />;
  }
  if (cfg.tipo === "contacto") {
    return <SelectContactosItem headersToken={headersToken} empresaId={empresaId} width="100%" style={{ width: "100%" }} placeholder="Buscar contacto..." dropdownStyle={dd} onChange={(id) => id && onSelect(id)} />;
  }
  return null;
};

const SelectorPlantillas = ({ visible, headersToken, empresaId, onCancel, onEnviar }) => {
  const [plantillas, setPlantillas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sel, setSel] = useState(null);
  const [analisis, setAnalisis] = useState(null);
  const [valoresHeader, setValoresHeader] = useState({});
  const [valoresBody, setValoresBody] = useState({});
  const [valoresBoton, setValoresBoton] = useState({}); // { indiceBoton: valor } para URLs dinámicas
  const [archivo, setArchivo] = useState(null);
  const [datosDoc, setDatosDoc] = useState(null);
  const [imagenDoc, setImagenDoc] = useState(null); // { link, display } imagen del documento
  const [documentoSelId, setDocumentoSelId] = useState(null); // id del documento 
  const [generarPdf, setGenerarPdf] = useState(false); // adjuntar el PDF del documento como encabezado
  const [cargandoDatos, setCargandoDatos] = useState(false);
  const [vistaPrevia, setVistaPrevia] = useState(null); // plantilla en vista previa

  const headers = { headers: headersToken };

  useEffect(() => {
    if (!visible) return;
    setSel(null); setAnalisis(null); setValoresHeader({}); setValoresBody({}); setArchivo(null); setDatosDoc(null); setImagenDoc(null); setDocumentoSelId(null); setGenerarPdf(false);
    setLoading(true);
    axios
      .post("whatsapp/plantillaListar", {}, headers)
      .then((r) => {
        if (r.data.success === 2)
          setPlantillas((r.data.plantillas || []).filter((p) => p.status === "APPROVED" && !p.deshabilitada));
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  const elegir = (pl) => {
    setSel(pl);
    setAnalisis(analizarPlantilla(pl));
    setValoresHeader({}); setValoresBody({}); setValoresBoton({}); setArchivo(null); setDatosDoc(null); setImagenDoc(null); setDocumentoSelId(null); setGenerarPdf(false);
  };

  // Al elegir un documento en el buscador, traer sus datos y autollenar variables por nombre.
  const onSelectDocumento = (documentoId) => {
    setDocumentoSelId(documentoId);
    setCargandoDatos(true);
    axios
      .post("whatsapp/datosPlantillaDocumento", { modelo: sel.modelo, documentoId }, headers)
      .then((r) => {
        if (r.data.success === 2) {
          const datos = r.data.datos || {};
          setDatosDoc(datos);
          setImagenDoc(r.data.imagen || null);
          setValoresBody((prev) => {
            const nb = { ...prev };
            analisis.varsBody.forEach((n) => { if (datos[n] != null) nb[n] = datos[n]; });
            return nb;
          });
          setValoresHeader((prev) => {
            const nh = { ...prev };
            analisis.varsHeader.forEach((n) => { if (datos[n] != null) nh[n] = datos[n]; });
            return nh;
          });
        } else {
          message.error(r.data.message || "No se pudieron cargar los datos.");
        }
      })
      .catch(() => message.error("Error de red al cargar el documento."))
      .finally(() => setCargandoDatos(false));
  };

  const esHeaderDocumento = !!analisis && analisis.header?.format === "DOCUMENT";
  const puedeGenerarPdf = esHeaderDocumento && MODELOS_PDF.includes(sel?.modelo) && !!documentoSelId;

  const enviar = () => {
    if (analisis.esHeaderMedia) {
      if (esHeaderDocumento) {
        if (!(generarPdf && puedeGenerarPdf) && !archivo)
          return message.error("Genera el PDF del documento o sube un archivo para el encabezado.");
      } else if (!archivo && !imagenDoc) {
        return message.error("Sube la imagen del encabezado.");
      }
    }
    if (analisis.varsBody.some((n) => !valoresBody[n]?.trim())) return message.error("Completa todas las variables del cuerpo.");
    if (analisis.varsHeader.some((n) => !valoresHeader[n]?.trim())) return message.error("Completa las variables del encabezado.");
    if (botonesUrlDinamicos(analisis).some(({ index }) => !valoresBoton[index]?.trim())) return message.error("Completa el dato de los botones de URL dinámica.");

    const components = construirComponentsEnvio(analisis, valoresHeader, valoresBody, valoresBoton);
    const textoPreview = rellenar(analisis.bodyTexto, valoresBody);
    const render = {
      headerTexto: analisis.esHeaderTexto ? rellenar(analisis.header.text, valoresHeader) : "",
      footerTexto: analisis.footerTexto || "",
      botones: analisis.botones || [],
    };

    const fd = new FormData();
    fd.append("name", sel.name);
    fd.append("language", sel.language);
    fd.append("components", JSON.stringify(components));
    fd.append("textoPreview", textoPreview);
    fd.append("render", JSON.stringify(render));
    if (analisis.esHeaderMedia) {
      fd.append("headerFormato", analisis.header?.format || "");
      if (esHeaderDocumento && generarPdf && puedeGenerarPdf) {
        fd.append("generarPdf", "true"); 
        fd.append("modelo", sel.modelo);
        fd.append("documentoId", documentoSelId);
      } else if (archivo) {
        fd.append("archivo", archivo); 
      } else if (imagenDoc) {
        fd.append("headerImagenLink", imagenDoc.link); 
        fd.append("headerImagenDisplay", imagenDoc.display);
      }
    }

    onEnviar(fd);
  };

  return (
    <ModalItem
      title={sel ? "Enviar plantilla" : "Plantillas de Mensaje"}
      visible={visible}
      onCancel={onCancel}
      width={620}
      zIndex={1000}
      destroyOnClose
      spinning={false}
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: 24 }}><Spin /></div>
      ) : !sel ? (
        <ListaItems
          dataSource={plantillas}
          rowKey="name"
          vacioTexto="No hay plantillas aprobadas. Crea una en Configuración → Plantillas."
          onItemClick={(pl) => elegir(pl)}
          titulo={(pl) => <Text style={{ color: WA.textPrimary }}>{pl.name}</Text>}
          descripcion={(pl) => (
            <>
              <Tag color="#52c41a">{etiquetaEstado(pl.status)}</Tag>
              {pl.modelo && <Tag color={WA.turquesa}>{etiquetaModelo(pl.modelo)}</Tag>}
              <Text style={{ fontSize: 12, color: WA.textSecondary }}>
                {(CATEGORIAS.find((c) => c.value === pl.category)?.label || pl.category)} · {pl.language}
              </Text>
            </>
          )}
          acciones={(pl) => [
            <Tooltip key="prev" title="Vista previa">
              <ButtonItem rosa icon={<EyeOutlined />} onClick={(e) => { e.stopPropagation(); setVistaPrevia(pl); }} />
            </Tooltip>,
          ]}
        />
      ) : (
        <>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
            <Text strong>{sel.name}</Text>
            {sel.modelo && <Tag color={WA.turquesa}>{etiquetaModelo(sel.modelo)}</Tag>}
            <ButtonItem morado icon={<SwapOutlined />} style={{ marginLeft: "auto" }} onClick={() => setSel(null)}>Cambiar</ButtonItem>
          </div>

          {sel.modelo && (
            <>
              <div style={{ fontWeight: 600, margin: "8px 0 4px" }}>
                Buscar {etiquetaModelo(sel.modelo).toLowerCase()} para autollenar
              </div>
              <BuscadorModelo modelo={sel.modelo} headersToken={headersToken} empresaId={empresaId} onSelect={onSelectDocumento} />
              {cargandoDatos && <div style={{ textAlign: "center", padding: 8 }}><Spin size="small" /></div>}
              {datosDoc && (
                <div style={{ border: `1px solid ${WA.border}`, borderRadius: 8, padding: 10, marginTop: 8, background: WA.bg }}>
                  <Text type="secondary" style={{ fontSize: 12 }}>Datos del documento (clic para copiar):</Text>
                  {Object.entries(datosDoc).map(([k, v]) => (
                    <div key={k} style={{ fontSize: 12, marginTop: 2 }}>
                      <Text type="secondary">{k}:</Text>{" "}
                      <Text copyable={{ text: String(v || "") }} style={{ color: WA.textPrimary }}>{String(v || "—")}</Text>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}

          {analisis.esHeaderMedia && esHeaderDocumento && (
            <>
              <div style={{ fontWeight: 600, margin: "8px 0 4px" }}>Documento del encabezado *</div>
              {puedeGenerarPdf && (
                <div style={{ marginBottom: 8, padding: 8, background: WA.bg, border: `1px solid ${WA.border}`, borderRadius: 8 }}>
                  <Checkbox checked={generarPdf} onChange={(e) => setGenerarPdf(e.target.checked)}>
                    <FilePdfOutlined style={{ color: "#d4380d", marginRight: 4 }} />
                    Generar y adjuntar el PDF de {etiquetaModelo(sel.modelo).toLowerCase()}
                  </Checkbox>
                </div>
              )}
              {esHeaderDocumento && MODELOS_PDF.includes(sel?.modelo) && !documentoSelId && (
                <Text type="secondary" style={{ fontSize: 12, display: "block", marginBottom: 6 }}>
                  Elige un documento arriba para poder generar su PDF, o sube un archivo manualmente.
                </Text>
              )}
              {!(generarPdf && puedeGenerarPdf) && (
                <Upload.Dragger accept=".pdf" showUploadList={false} beforeUpload={(f) => { setArchivo(f); return false; }}>
                  <p className="ant-upload-drag-icon"><InboxOutlined /></p>
                  <p className="ant-upload-text">
                    {archivo ? `Seleccionado: ${archivo.name}` : "Sube un PDF para el encabezado"}
                  </p>
                </Upload.Dragger>
              )}
            </>
          )}

          {analisis.esHeaderMedia && !esHeaderDocumento && (
            <>
              <div style={{ fontWeight: 600, margin: "8px 0 4px" }}>Imagen del encabezado *</div>
              {imagenDoc && !archivo && (
                <div style={{ marginBottom: 6 }}>
                  <img src={imagenDoc.display} alt="" style={{ maxWidth: 120, borderRadius: 8, border: `1px solid ${WA.border}`, background: "#fff" }} />
                  <Text type="secondary" style={{ fontSize: 12, display: "block" }}>
                    Se usará la imagen del documento. Sube otra si quieres reemplazarla.
                  </Text>
                </div>
              )}
              <Upload.Dragger accept="image/*" showUploadList={false} beforeUpload={(f) => { setArchivo(f); return false; }}>
                <p className="ant-upload-drag-icon"><InboxOutlined /></p>
                <p className="ant-upload-text">
                  {archivo ? `Seleccionada: ${archivo.name}` : imagenDoc ? "Subir otra imagen (opcional)" : "Sube la imagen"}
                </p>
              </Upload.Dragger>
            </>
          )}

          {analisis.varsHeader.length > 0 && (
            <>
              <div style={{ fontWeight: 600, margin: "8px 0 4px" }}>Variables del encabezado</div>
              {analisis.varsHeader.map((n) => (
                <FilaVar key={n} etiqueta={n}>
                  <InputItem placeholder={`Valor de {{${n}}}`} value={valoresHeader[n] || ""}
                    onChange={(e) => setValoresHeader((p) => ({ ...p, [n]: e.target.value }))} />
                </FilaVar>
              ))}
            </>
          )}

          {analisis.varsBody.length > 0 && (
            <>
              <div style={{ fontWeight: 600, margin: "8px 0 4px" }}>Variables del cuerpo</div>
              {analisis.varsBody.map((n) => (
                <FilaVar key={n} etiqueta={n}>
                  <InputItem placeholder={`Valor de {{${n}}}`} value={valoresBody[n] || ""}
                    onChange={(e) => setValoresBody((p) => ({ ...p, [n]: e.target.value }))} />
                </FilaVar>
              ))}
            </>
          )}

          {botonesUrlDinamicos(analisis).length > 0 && (
            <>
              <div style={{ fontWeight: 600, margin: "8px 0 4px" }}>Datos de botones (URL dinámica)</div>
              {botonesUrlDinamicos(analisis).map(({ index, b }) => (
                <FilaVar key={index} etiqueta={b.text || "URL"}>
                  <InputItem placeholder="valor del enlace" value={valoresBoton[index] || ""}
                    onChange={(e) => setValoresBoton((p) => ({ ...p, [index]: e.target.value }))} />
                </FilaVar>
              ))}
            </>
          )}

          <Divider style={{ margin: "12px 0 8px" }} />
          <Text type="secondary" style={{ fontSize: 12 }}>Vista previa</Text>
          <div style={{ border: `1px solid ${WA.border}`, borderRadius: 8, padding: 10, marginTop: 4, backgroundColor: WA.bg }}>
            <PreviewPlantilla
              plantilla={sel}
              valores={{ ...valoresHeader, ...valoresBody }}
              imagenUrl={esHeaderDocumento ? undefined : archivo ? URL.createObjectURL(archivo) : imagenDoc?.display}
            />
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 16 }}>
            <ButtonItem rojo onClick={onCancel}>Cancelar</ButtonItem>
            <ButtonItem cyan onClick={enviar}>Enviar</ButtonItem>
          </div>
        </>
      )}

      {/* Vista previa al elegir la plantilla (sin seleccionarla para enviar) */}
      <ModalItem
        title={`Vista previa: ${vistaPrevia?.name || ""}`}
        visible={!!vistaPrevia}
        onCancel={() => setVistaPrevia(null)}
        width={420}
        zIndex={1300}
        destroyOnClose
        spinning={false}
      >
        {vistaPrevia && (
          <>
            <Text type="secondary" style={{ fontSize: 12 }}>Así se ve la plantilla con datos de ejemplo:</Text>
            <div style={{ border: `1px solid ${WA.border}`, borderRadius: 8, padding: 12, marginTop: 6, backgroundColor: WA.bg }}>
              <PreviewPlantilla plantilla={vistaPrevia} valores={valoresEjemplo(vistaPrevia, analizarPlantilla(vistaPrevia))} />
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 16 }}>
              <ButtonItem gris onClick={() => setVistaPrevia(null)}>Cerrar</ButtonItem>
              <ButtonItem cyan onClick={() => { elegir(vistaPrevia); setVistaPrevia(null); }}>Usar esta</ButtonItem>
            </div>
          </>
        )}
      </ModalItem>
    </ModalItem>
  );
};

export default SelectorPlantillas;
